import { z } from 'zod';
import { emailBodySchema } from './emailBody.js';
/**
 * Templates, over the wire.
 *
 * A template is the *source* somebody wrote: a subject and a body,
 * both of which may carry merge placeholders. A campaign stores the rendered
 * html and text instead, frozen at create — which is why a campaign cannot be
 * loaded back into a form and a template can.
 *
 * Starting a campaign from a template copies the content rather than linking to
 * it. Editing a template must never change what a campaign already sent.
 */
export const templateSchema = z.object({
    templateId: z.string(),
    name: z.string(),
    subject: z.string(),
    body: emailBodySchema,
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const templateListSchema = z.object({ templates: z.array(templateSchema) });
export const saveTemplateRequestSchema = z.object({
    name: z.string().trim().min(1, 'a template needs a name').max(120),
    subject: z.string().trim().min(1, 'a template needs a subject').max(200),
    body: emailBodySchema,
});
/**
 * Saving answers one of two ways, and a form acts on each.
 *
 * `name-taken` is not an error: somebody retyping a name they already used has
 * made an ordinary mistake and should be told so beside the field, not handed a
 * status code.
 */
export const saveTemplateResponseSchema = z.discriminatedUnion('status', [
    z.object({ status: z.literal('saved'), templateId: z.string() }),
    z.object({ status: z.literal('name-taken') }),
]);
/**
 * Copying one answers with the name it ended up with.
 *
 * The name comes back because the server picked it: the browser cannot see the
 * other names without a second request, and a client that guessed would offer
 * "Monthly update (copy)" to somebody who already has one and then refuse its
 * own suggestion. The screen says which card is the new one.
 */
export const duplicateTemplateResponseSchema = z.object({
    templateId: z.string(),
    name: z.string(),
});
//# sourceMappingURL=templates.js.map